/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Badge, ListItem, ListItemButton, Typography } from "@mui/material";
import { Link, useLocation } from "react-router";
import { EmailOutlined } from "@mui/icons-material";
import { mergeSx } from "@/src/utils/mergeSx";
import { authenticatedNavigationStyle } from "@/src/components/Navigation/AuthenticatedNavigation/authenticatedNavigationStyle";
import { useBasicAccountData } from "@/src/provider/BasicAccountData/BasicAccountDataProvider";

export default function AuthenticatedNavigationLinkMessages() {

  const location = useLocation();
  const { newMessages } = useBasicAccountData();

  const linkPath = "/servicewelt/nachrichten";

  return (
    <ListItem disableGutters disablePadding>
      <ListItemButton
        component={Link}
        to={linkPath}
        sx={mergeSx(authenticatedNavigationStyle.link, location.pathname === linkPath && authenticatedNavigationStyle.linkActive, { margin: "0.25rem 0" })}
      >
        <Badge color={"warning"} badgeContent={newMessages?.length} sx={{ marginRight: "1.25rem" }}>
          <EmailOutlined sx={(theme) => ({ color: theme.palette.common.black })} />
        </Badge>
        <Typography component={"span"} variant={"h7"}>
          Nachrichten
        </Typography>
      </ListItemButton>
    </ListItem>
  );
}
